export const MICROSERVICES = {
    vehicles: '/cve-vehicles',
    oemConnector: '/cve-oem-connector',
};
